import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { CdnImg } from '@webplatform/cdn-image';
import { useMediaAsset } from '~/composables';
import { handleImageSrc, handleImageAlt } from '~/helpers';

interface Props {
  image?: any;
  images?: any;
  styles?: any;
  isMobile?: boolean;
  isHover?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CatalogCategoryItemImages',
  props: {
    image: { default: () => ({}) },
    images: { default: () => ({}) },
    styles: { default: () => ({}) },
    isMobile: { type: Boolean, default: false },
    isHover: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { image: any, images: any, styles: any, isMobile: boolean, isHover: boolean };



const { getAssetUrl } = useMediaAsset();

const desktopImageTypes = computed(() =>
  ['primary', 'secondary'].filter((type) => props.images?.[type]),
);

const getImage = (image: string | object) => getAssetUrl(handleImageSrc(image));

const getStyles = (type: string, hover: boolean = false) =>
  props.styles?.[hover ? 'hover' : 'base']?.[type];

return { __sfc: true,props, getAssetUrl, desktopImageTypes, getImage, getStyles, CdnImg, handleImageSrc, handleImageAlt }
}

})